<template>
  <el-dialog :visible.sync="visibleSync" width="760px" :show-close="false" :modal-append-to-body="false"
    :lock-scroll="false">
    <div slot="title" style="display:flex;justify-content:space-between;align-items:center;width:100%">
      <h3>Thêm mới bài tập về nhà cần thanh tra</h3>
      <i class="el-icon-close" style="cursor:pointer" @click="close"></i>
    </div>

    <ValidationObserver ref="observer">
      <div>
        <div class="row">
          <div class="col-6 mt-3">
            <label>Thời gian chấm bài tập về nhà <span class="text-danger">*</span></label>
            <ValidationProvider name="Thời gian chấm bài tập về nhà" rules="required" v-slot="{ errors }">
              <date-picker class="w-100" v-model="form.date_times" type="date" format="DD-MM-YYYY"
                value-type="YYYY-MM-DD" range placeholder="Chọn khoảng thời gian" :append-to-body="false" @change="handleRangeChange('date_times', $event)" />
              <input type="hidden" v-model="gradedProxy">
              <div class="text-danger mt-1" v-if="errors[0]">Thời gian chấm bài tập về nhà không được bỏ trống</div>
            </ValidationProvider>
          </div>
          <div class="col-6 mt-3" ref="teacherArea">
            <label>Chọn giảng viên cần thanh tra <span class="text-danger">*</span></label>
            <el-popover v-model="teacherPopoverVisible" placement="bottom-start" width="540" trigger="manual"
              :append-to-body="false">
              <div class="mb-2 filter-row">
                <el-select v-model="teacherFilter.centers" class="mr-2" multiple clearable collapse-tags
                  placeholder="Chọn trung tâm" :popper-append-to-body="false">
                  <el-option v-for="c in centers" :key="c.id" :label="c.name" :value="c.id" />
                </el-select>
                <el-select v-model="teacherFilter.risk_types" multiple clearable collapse-tags
                  placeholder="Chọn loại giảng viên" :popper-append-to-body="false">
                  <el-option v-for="r in riskTypeOptions" :key="r.value" :label="r.label" :value="r.value" />
                </el-select>
              </div>
              <el-input v-model="teacherFilter.search" placeholder="Tìm kiếm giảng viên" class="mb-2" />
              <div class="select-all-row mb-2">
                <el-checkbox v-model="selectAllChecked" :disabled="teacherList.length === 0"
                  @change="toggleSelectAll">Chọn tất cả</el-checkbox>
                <span class="ml-3 text-muted">({{ teacherList.length }} giảng viên)</span>
              </div>
              <div class="teacher-list">
                <div v-if="teacherList.length === 0 && !loadingTeachers" class="empty-text">Không có giảng viên</div>
                <template v-else-if="!bulkSelecting && !loadingTeachers">
                  <el-checkbox-group v-model="form.teacher_ids" @change="onTeacherIdsChange">
                    <el-checkbox v-for="t in teacherList" :key="t.id" :label="t.id">{{ `${t.id + 100000} - ${t.name}`
                      }}</el-checkbox>
                  </el-checkbox-group>
                </template>
                <div v-else-if="bulkSelecting || loadingTeachers" class="bulk-skeleton">
                  <el-skeleton animated :rows="6" />
                </div>
                
              </div>

              <el-select slot="reference" v-model="form.teacher_ids" class="w-100" multiple collapse-tags
                :no-data-text="''" placeholder="Chọn giảng viên" popper-class="hide-select-dropdown"
                @click.native="openTeacherPopover" @change="onTeacherIdsChange">
                <el-option v-for="t in selectedTeachers" :key="t.id" :label="`${t.id + 100000} - ${t.name}`"
                  :value="t.id" />
              </el-select>
            </el-popover>
            <div class="text-danger mt-1" v-if="submitted && (!form.teacher_ids || form.teacher_ids.length === 0)">
              Giảng viên thanh tra không được bỏ trống
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mt-3">
            <label>Số lượng BTVN/Giảng viên/Khóa học <span class="text-danger">*</span></label>
            <ValidationProvider name="Số lượng" rules="required|integer|min_value:1|max_value:10" v-slot="{ errors }">
              <el-input v-model.number="form.quantity" type="text" inputmode="numeric" pattern="[0-9]*"
                placeholder="Nhập số lượng" class="w-100"
                @input="sanitizeQuantity" @blur="sanitizeQuantity()" />
              <div class="text-danger mt-1" v-if="errors[0]">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="col-6 mt-3">
            <label>Hình thức bài tập</label>
            <el-select v-model="form.exercise_format" class="w-100" placeholder="Tất cả">
              <el-option label="Tất cả" :value="''" />
              <el-option label="Speaking" value="1" />
              <el-option label="Writing" value="2" />
            </el-select>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mt-3 d-flex align-items-center">
            <label class="mr-3 mb-0">Loại bỏ dữ liệu trùng</label>
            <el-switch v-model="duplicate_on" />
          </div>
          <div v-if="duplicate_on" class="col-6 mt-3">
            <label>Thời gian cần lọc trùng <span class="text-danger">*</span></label>
            <ValidationProvider name="Thời gian cần lọc trùng" :rules="duplicate_on ? 'required' : ''"
              v-slot="{ errors }">
              <date-picker class="w-100" :disabled="!duplicate_on" v-model="form.repeat_time" type="date"
                format="DD-MM-YYYY" value-type="YYYY-MM-DD" range placeholder="Chọn khoảng thời gian" @change="handleRangeChange('repeat_time', $event)"
                :append-to-body="false" />
              <input type="hidden" v-model="duplicateProxy">
              <div class="text-danger mt-1" v-if="errors[0]">Thời gian cần lọc trùng không được bỏ trống</div>
            </ValidationProvider>
          </div>
        </div>

        <div class="mt-3 text-muted">
          <el-skeleton :loading="loadingPreview" animated :throttle="100" :count="1">
            <template slot="template">
              <div class="preview-skeleton">
                <div class="skeleton-bar short"></div>
                <div class="skeleton-bar tiny ml-2"></div>
              </div>
            </template>
            <template>
              Số lượng bản ghi dự kiến: <b>{{ preview.total }}</b> (<b>{{ preview.total_teachers }}</b> giảng viên)
            </template>
          </el-skeleton>
        </div>
      </div>
    </ValidationObserver>

    <div slot="footer" class="dialog-footer d-flex justify-content-end">
      <button class="mt-2 btn btn-secondary font-weight-bold mr-2" @click="close">
        Hủy bỏ
      </button>

      <button class="mt-2 btn btn-primary font-weight-bold" @click="confirm" :disabled="submitting || loadingPreview">
        <span v-if="!submitting"> Xác nhận</span>
        <span v-else> Đang xử lý...</span>
      </button>
    </div>

  </el-dialog>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { GET_CENTERS } from '@/core/services/store/center/centers.module';
import { INSPECTION_CREATE_PREVIEW, INSPECTION_CREATE, INSPECTION_TEACHER_CATEGORY_LIST, INSPECTION_GET_HOMEWORK } from '@/core/services/store/inspection/inspection.module';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, integer, min_value, max_value } from 'vee-validate/dist/rules';
export default {
  name: 'InspectionCreateModal',
  components: { DatePicker, ValidationObserver, ValidationProvider },
  props: { visible: { type: Boolean, default: false } },
  data() {
    return {
      visibleSync: this.visible,
      submitted: false,
      submitting: false,
      duplicate_on: true,
      form: {
        date_times: this.getCurrentMonthRange(),
        teacher_ids: [],
        quantity: null,
        exercise_format: '',
        repeat_time: [],
        inspection_type: 'dinh_ky',
      },
      centers: [],
      teacherFilter: { centers: [], risk_types: [], search: '', date_range: this.getCurrentMonthRange()},
      riskTypeOptions: [{ label: 'An toàn', value: 1 },
        { label: 'Rủi ro', value: 2 },
        { label: 'Rủi ro cao', value: 3 },
        ],
      teacherList: [],
      selectedTeachers: [],
      teacherPopoverVisible: false,
      selectAllChecked: false,
      preview: { total: 0, total_teachers: 0 },
      loadingPreview: false,
      bulkSelecting: false,
      loadingTeachers: false,
    };
  },
  // merge lifecycle hooks to avoid duplicate 'created' overriding each other
  created() {
    // register validation rules
    extend('required', required);
    extend('integer', {
      ...integer,
      message: 'Số lượng không hợp lệ'
    });
    extend('min_value', {
      ...min_value,
      message: 'Số lượng không hợp lệ'
    });
    extend('max_value', {
      ...max_value,
      message: 'Tối đa 10'
    });
    // initial data
    this.fetchCenters();
    this.fetchTeachers();
    document.addEventListener('click', this.onDocumentClick, true);
  },
  watch: {
    visible(v) { this.visibleSync = v; },
    visibleSync(v) { this.$emit('update:visible', v); },
    duplicate_on() { this.previewRequest(); },
    'form.date_times': {
      handler(newVal) {
        // Update teacherFilter.date_range when date_times changes
        this.teacherFilter.date_range = newVal;
        // Clear selected teachers when date range changes to avoid invalid selections
        if (this.form.teacher_ids.length > 0) {
          this.form.teacher_ids = [];
          this.selectedTeachers = [];
        }
      },
      deep: true,
    },
    form: {
      handler() { this.previewRequestDebounced(); },
      deep: true,
    },
    teacherFilter: {
      handler() { this.fetchTeachersDebounced(); },
      deep: true,
    },

    // Keep select-all in sync even when user removes selections from the outside select
    'form.teacher_ids'(val) {
      this.updateSelectAllChecked();
    },
  },
  computed: {
    gradedProxy() { return this.isFilled(this.form.date_times) ? 'ok' : ''; },
    teacherProxy() { return (this.form.teacher_ids && this.form.teacher_ids.length) ? 'ok' : ''; },

    duplicateProxy() { return (!this.duplicate_on || this.isFilled(this.form.repeat_time)) ? 'ok' : ''; },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick, true);
  },
  methods: {
    sanitizeQuantity(val = this.form.quantity) {
      const raw = (val === undefined || val === null) ? '' : String(val);
      // Keep only digits, take integer part, clamp to [1,10]
      const digits = raw.replace(/\D+/g, '');
      if (digits === '') { this.form.quantity = null; return; }
      const n = Math.min(10, Math.max(1, parseInt(digits, 10)));
      if (n !== this.form.quantity) this.form.quantity = n;
    },
    handleRangeChange(field, value) {
      if (Array.isArray(value) && value.length === 2 && value[0] === null && value[1] === null) {
        this.$set(this.form, field, []);
      } else {
        this.$set(this.form, field, value);
      }
    },
    getCurrentMonthRange() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      
      // First day of current month
      const firstDay = new Date(year, month, 1);
      // Current day (today)
      const today = new Date(year, month, now.getDate());
      
      // Format as YYYY-MM-DD
      const formatDate = (date) => {
        return date.getFullYear() + '-' + 
               String(date.getMonth() + 1).padStart(2, '0') + '-' + 
               String(date.getDate()).padStart(2, '0');
      };
      
      return [formatDate(firstDay), formatDate(today)];
    },
    isFilled(arr) { 
      return Array.isArray(arr) && arr.length === 2 && arr[0] && arr[1]; 
    },
    close() { this.visibleSync = false; },
    openTeacherPopover() {
      this.teacherPopoverVisible = true;
    },
    onDocumentClick(e) {
      if (!this.teacherPopoverVisible) return;
      const area = this.$refs.teacherArea;
      if (area && !area.contains(e.target)) {
        this.teacherPopoverVisible = false;
      }
    },
    async fetchCenters() {
      console.log('fetchCenters');
      const res = await this.$store.dispatch(GET_CENTERS, { limit: 10000, status: 1, is_edutalk: '1' });
      console.log(res,'res');
      if (!res.error) {
        this.centers = Object.values(res.data.data).map((x) => ({ id: x.id, name: x.name }));
      }
    },
    async fetchTeachers() {
      this.loadingTeachers = true;
      try {
        const { centers, risk_types, search, date_range } = this.teacherFilter;
        const res = await this.$store.dispatch(INSPECTION_TEACHER_CATEGORY_LIST, {
          keyword: search,
          'type_teachers': risk_types,
          is_all: 1,
          'center_ids': centers,
          'date_range': date_range
        });
        this.teacherList = res.data || [];
        // Update select-all state
        this.updateSelectAllChecked();
      } catch (error) {
        console.error('Error fetching teachers:', error);
        this.teacherList = [];
      } finally {
        this.loadingTeachers = false;
      }
    },
    updateSelectAllChecked() {
      if (!this.teacherList.length) { this.selectAllChecked = false; return; }
      const codes = new Set(this.form.teacher_ids);
      this.selectAllChecked = this.teacherList.every(t => codes.has(t.id));
    },
    toggleSelectAll(val) {
      // Batch update to avoid rendering thousands of checkbox updates
      this.bulkSelecting = true;
      this.$nextTick(() => {
        if (val) {
          // Use slice to create a new array reference at once
          this.form.teacher_ids = this.teacherList.map(t => t.id);
        } else {
          this.form.teacher_ids = [];
        }
        // Sync selected teacher objects
        this.onTeacherIdsChange(this.form.teacher_ids);
        // Give DOM a tick to avoid heavy re-render then show back
        this.$nextTick(() => { this.bulkSelecting = false; });
      });
    },
    onTeacherIdsChange() {
      const map = new Map(this.teacherList.map((t) => [t.id, t]));
      this.selectedTeachers = this.form.teacher_ids.map((c) => map.get(c)).filter(Boolean);
      this.updateSelectAllChecked();
    },
    async previewRequest() {
      const ok = this.isFilled(this.form.date_times) && this.form.teacher_ids.length && this.form.quantity;
      if (!ok) { this.preview = { total: 0, total_teachers: 0 }; return; }
      
      const payload = {
        date_time: this.form.date_times,
        quantity: this.form.quantity,
        teacher_ids: this.form.teacher_ids,
        duplicate: this.duplicate_on,
        repeat_time: this.duplicate_on ? this.form.repeat_time : undefined,
        exercise_format: this.form.exercise_format,
      };
      
      try {
        this.loadingPreview = true;
        const res = await this.$store.dispatch(INSPECTION_GET_HOMEWORK, payload);
        this.preview = {
          total: res.data?.total || 0,
          total_teachers: res.data?.total_teacher || 0
        };
      } catch (error) {
        console.error('Error fetching homework preview:', error);
        this.$message.error('Có lỗi xảy ra!');
        this.preview = { total: 0, total_teachers: 0 };
      } finally {
        this.loadingPreview = false;
      }
    },
    previewRequestDebounced: (() => {
      const _ = require('lodash');
      return _.debounce(function () { this.previewRequest(); }, 250);
    })(),
    fetchTeachersDebounced: (() => {
      const _ = require('lodash');
      return _.debounce(function () { this.fetchTeachers(); }, 250);
    })(),
    async confirm() {
      
      this.submitted = true;

      // Check all ValidationProvider rules first
      const ok = await this.$refs.observer.validate();
      
      // Then check manual validation for teacher selection
      const hasTeachers = this.form.teacher_ids && this.form.teacher_ids.length > 0;
      
      if (!ok || !hasTeachers) {
        return;
      }

      if(this.preview.total === 0) {
        this.$message.error('Không có bài tập thanh tra');
        return;
      }
      
      this.submitting = true;
      try {
        await this.$store.dispatch(INSPECTION_CREATE, { ...this.form, duplicate: this.duplicate_on });
        this.$emit('created');
        this.close();
      } finally {
        this.submitting = false;
      }
    },
    onlyAllowDigits(e) {
      const char = String.fromCharCode(e.which);
      if (!/[0-9]/.test(char)) {
        e.preventDefault();
      }
    },
    onPasteDigits(e) {
      const text = (e.clipboardData || window.clipboardData).getData('text');
      if (!/^\d+$/.test(text)) return; // allow only digits
      // Manually set paste since we prevented default
      const current = String(this.form.quantity || '');
      const selectionSupported = e.target && typeof e.target.selectionStart === 'number';
      if (selectionSupported) {
        const el = e.target;
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const next = current.slice(0, start) + text + current.slice(end);
        this.$nextTick(() => { this.form.quantity = Number(next); });
      } else {
        this.$nextTick(() => { this.form.quantity = Number(current + text); });
      }
    },
  },
};
</script>

<style>
.teacher-list {
  min-height: 260px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 8px 10px;
}

.hide-select-dropdown {
  display: none !important;
}

/* Keep filter selects and header row tidy */
.filter-row .el-select .el-input__inner {
  cursor: pointer;
}

.select-all-row {
  display: flex;
  align-items: center;
}

.select-all-row .text-muted {
  margin-left: 8px;
}

.select-all-row .el-checkbox {
  margin: 0;
}

.empty-text {
  padding: 12px 4px;
  color: #999;
}

/* Force checkbox list to single column to avoid wrapping into uneven columns */
.teacher-list .el-checkbox {
  display: flex !important;
  align-items: center;
  width: 100%;
  margin: 8px 0;
}

.select-all-row .el-checkbox {
  display: flex;
  align-items: center;
}

.teacher-list .el-checkbox__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-skeleton {
  display: flex;
  align-items: center;
}
.skeleton-bar {
  height: 14px;
  background: #eee;
  border-radius: 6px;
}
.skeleton-bar.short { width: 160px; }
.skeleton-bar.tiny { width: 90px; }
.ml-2 { margin-left: 8px; }

.bulk-skeleton {
  padding: 8px 4px;
}
</style>
